import { useState, useEffect } from "react";
import styled from 'styled-components';
import { Modal, Button, LoadingIcon } from '@prosolve/common-components-ui'
import useForm from '../../hooks/useForm';
import useFetch from '../../hooks/useFetch';
import { FormField } from '@prosolve/common-components-ui'

const Header = styled.div`
  display: flex;
  align-items: center;
  color: #565656;
  font-weight: bold;
`

const Title = styled.div`
  font-size: 22px;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  column-gap: 10px;
  padding: 10px;
`

const HorizontalDivider = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  gap: 15px;
  color: #565656;
  margin: 10px 0px;

  &::before,
  &::after {
    content: "";
    flex: 1;
    border-bottom: 1px solid #C2C9D1;
  }
`;

const Note = styled.div`
  margin-top: -5px;
  font-size: 13px;
  font-style: italic;
  color: #565656;
`

export default ({
  assessment = {},
  allAssessments = [],
  reloadData,
  onClose,
  onConfirmation
}) => {
  const fetch = useFetch();

  const { _id: assessmentId, folder: initFolder = '' } = assessment

  const folders = [ ...new Set(allAssessments.map(({ folder }) => folder).filter(Boolean)) ]

  const folderOptions = folders.map(folder => ({ text: folder, value: folder }))
  folderOptions.unshift({ text: '--- No Folder ---', value: '' })

  const formSchema = {
    requiredFields: ['existingFolder', 'newFolder'],
    initData: { existingFolder: initFolder, newFolder: '' }
  }

  const formData = useForm(formSchema)

  const [isValid, setIsValid] = useState(false)

  const [isBusy, setIsBusy] = useState(false)

  useEffect(() => {
    const { existingFolder, newFolder } = formData.values
    if (newFolder || (existingFolder !== initFolder )) {
      setIsValid(true)
    } else {
      setIsValid(false)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.values])

  const onSubmit = async () => {
    if (isValid) {
      try {
        setIsBusy(true)
        const { existingFolder, newFolder } = formData.values
        const folderToSet = newFolder || existingFolder

        const response = await fetch(`assessment/builder/setFolder`, 
        { 
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ assessmentId, folder: folderToSet })
        })

        const jsonData = await response.json();

        if (jsonData.success) {
          // Need to set the assessment we started from to the newly edited assessment to be our new latest and greatest
          // fetchAssessment();
          reloadData()
          onClose()
        }


        setIsBusy(false)
      } catch (e) {
        console.log(e)
        setIsBusy(false)
      }
    }
  }

  const TitleComponent = (
    <Header>
      <Title>
        {'Add to Folder'}
      </Title>
    </Header>
  )

  const baseButtonStyle = {
    padding: '10px',
    fontSize: '18px',
    borderRadius: '10px',
    width: '100px'
  }

  const FooterComponent = (
    <ButtonsContainer>
      <Button style={baseButtonStyle} onClick={onClose}>
        {'Cancel'}
      </Button>
      <Button style={{ ...baseButtonStyle, fontWeight: 'bold', position: 'relative' }} onClick={onSubmit} $colored={true} $disabled={!isValid || isBusy}>
        {
          isBusy ?
          <>
            &nbsp;
            <div style={{ position: 'absolute', top: '3px' }}>
              <LoadingIcon />
            </div>
          </>
          :
          'Submit'
        }
      </Button>
    </ButtonsContainer>
  )

  return (
    <Modal 
      title={TitleComponent}
      // isAutoHeight={true} 
      closeOnOffClick={false}
      footer={FooterComponent} 
      onClose={onClose}
    >
      <Content>
        <FormField
          fieldId='existingFolder'
          type='select'
          label='Add to existing folder'
          formData={formData}
          options={folderOptions}
          style={{ flex: 1 }}
          width="100%"
        />
        <HorizontalDivider>Or</HorizontalDivider>
        <FormField
          fieldId='newFolder'
          type='text'
          label='Create and add to a new folder'
          formData={formData}
        />
        <Note>{'If any value is detected here, new folder creation will be used and override any existing folders selected above.'}</Note>
      </Content>
    </Modal>
  )
}